import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { proxyAPI } from "../../proxyAPI";
import MyPagination from "../../Common/MyPagination";
import { faAngleDown, faAngleUp, faRefresh, faRotate, faRotateLeft } from "@fortawesome/free-solid-svg-icons";

const { baseUrl: baseURL } = JSON.parse(
  document.querySelector("#app").dataset.page
).props;

export default function WorkflowLogs({ GUID, runtimeID, handleClose }) {
  const { projectID } = useParams();
  const [logs, setLogs] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [order, setOrder] = useState(true); // true is desc
  const [reset, setReset] = useState(Date.now());

  const loader = async (page = 0, perPage = 10) => {
    setLoading(true);
    const data = await proxyAPI({
      prefix: "logic/workflows/api",
      url: `/process-logs?guid=${GUID}${
        runtimeID ? `&runtime_id=${runtimeID}` : ""
      }${message ? `&message=${message}` : ""}&offset=${
        page * perPage
      }&limit=${perPage}&order=${order ? "desc" : "asc"}`,
    });
    setTimeout(() => {
      setLoading(false);
      if (data.logs) {
        setTotal(data.total);
        setLogs(data.logs);
      }
    }, 500);
  };

  return (
    <Modal size="xl" scrollable show={GUID || runtimeID} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          Process logs
          {loading ? (
            <span className="ms-2">
              <FontAwesomeIcon icon={faRotate} spin />
            </span>
          ) : (
            <button
              type="button"
              className="btn btn-link"
              onClick={() => setReset(Date.now())}
            >
              <FontAwesomeIcon icon={faRefresh} />
            </button>
          )}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <table className="table">
            <thead>
              <tr>
                <th>
                  At
                  <button
                    type="button"
                    className="btn btn-link align-baseline ms-2"
                    onClick={() => {
                      setOrder((p) => !p);
                      setReset(Date.now());
                    }}
                  >
                    {order ? (
                      <FontAwesomeIcon icon={faAngleDown} />
                    ) : (
                      <FontAwesomeIcon icon={faAngleUp} />
                    )}
                  </button>
                </th>
                <th>
                  Message{" "}
                  {message ? (
                    <button
                      className="btn btn-link p-0 mx-2"
                      title="Clear message filter"
                      type="button"
                      onClick={() => {
                        setMessage(null);
                        setReset(Date.now());
                      }}
                    >
                      <FontAwesomeIcon icon={faRotateLeft} />
                    </button>
                  ) : (
                    ""
                  )}
                </th>
                <th>Event type</th>
                <th>Details</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={5} className="text-center text-primary">
                    <FontAwesomeIcon
                      style={{ fontSize: 100 }}
                      icon={faRotate}
                      spin
                    />
                  </td>
                </tr>
              ) : (
                <>
                  {logs.map((log) => (
                    <tr key={log.ID}>
                      <td>{new Date(log.At).toLocaleString()}</td>
                      <td>
                        <button
                          type="button"
                          className="btn btn-link p-0"
                          title="Filter logs by message"
                          onClick={() => {
                            setMessage(log.Message);
                            setReset(Date.now());
                          }}
                        >
                          {log.Message.replaceAll(":", " ").replaceAll(
                            "-",
                            " "
                          )}
                        </button>
                      </td>
                      <td>{log.Data.eventType}</td>
                      <td>
                        {log.Data.templateUUID ? (
                          <a
                            target={`project_${projectID}`}
                            className="btn btn-outline-secondary btn-sm p-0 px-1 me-1"
                            href={`${baseURL}/workflows/builder/${projectID}/message-template/${log.Data.templateUUID}`}
                          >
                            Message template: {log.Data.label}
                          </a>
                        ) : (
                          ""
                        )}
                        {log.Data.workflowUUID ? (
                          <a
                            target={`project_${projectID}`}
                            className="btn btn-outline-secondary btn-sm p-0 px-1 me-1"
                            href={`${baseURL}/workflows/builder/${projectID}/workflow/${log.Data.workflowUUID}`}
                          >
                            workflow
                          </a>
                        ) : (
                          ""
                        )}
                        {log.Data.workflowUUID && log.Data.eventType ? (
                          <>
                            {" > "}
                            <a
                              target={`project_${projectID}`}
                              className="btn btn-outline-secondary btn-sm p-0 px-1 me-1"
                              href={`${baseURL}/workflows/builder/${projectID}/workflow/${log.Data.workflowUUID}/event/${log.Data.eventType}`}
                            >
                              event
                            </a>
                          </>
                        ) : (
                          ""
                        )}
                        {log.Data.workflowUUID &&
                        log.Data.eventType &&
                        log.Data.eventListenerUUID ? (
                          <>
                            {" > "}
                            <a
                              target={`project_${projectID}`}
                              className="btn btn-outline-secondary btn-sm p-0 px-1 me-1"
                              href={`${baseURL}/workflows/builder/${projectID}/workflow/${log.Data.workflowUUID}/event/${log.Data.eventType}/listener/${log.Data.eventListenerUUID}`}
                            >
                              event listener
                            </a>
                          </>
                        ) : (
                          ""
                        )}
                        {log.Data.workflowUUID &&
                        log.Data.eventType &&
                        log.Data.eventListenerUUID &&
                        log.Data.actionUUID ? (
                          <>
                            {" > "}
                            <a
                              target={`project_${projectID}`}
                              className="btn btn-outline-secondary btn-sm p-0 px-1 me-1"
                              href={`${baseURL}/workflows/builder/${projectID}/workflow/${log.Data.workflowUUID}/event/${log.Data.eventType}/listener/${log.Data.eventListenerUUID}/action/${log.Data.actionUUID}`}
                            >
                              action
                            </a>
                          </>
                        ) : (
                          ""
                        )}
                        {log.Message === "broadcast-message:sent" ? (
                          <>
                            <span className="badge text-bg-secondary">
                              {log.Data?.address}
                            </span>{" "}
                            <span className="badge text-bg-secondary">
                              {log.Data?.type}
                            </span>
                          </>
                        ) : (
                          ""
                        )}
                      </td>
                    </tr>
                  ))}
                </>
              )}
            </tbody>
          </table>
        </div>

        <MyPagination total={total} onPaginate={loader} key={reset} />
      </Modal.Body>
    </Modal>
  );
}
